import { useEffect, useState } from "react";
import { PendingOrderProgressBarVisibleConstansts } from "../../common/constants";
import PendingOrderProgressBar from "./PendingOrderProgressBar";
import { GetMissingInfoDetails, orderSummarySelector } from "../../features/ordersSummary/orderSummarySlice";
import { useDispatch, useSelector } from "react-redux";
import { getOrderStatusTipDetails } from "../../common/utils";

export const columns = (userLogin, t) => {
  //const { t } = useTranslation();
  return [
    {
      Header: t("OrdernumHeader"),
      accessor: "fileNumber",
      width: 30,
      sortable: true,
      Cell: ({ row }) => {
        //spread the props
        //const redirectURL = `process/${row.original.filenumberEncrypted}`;
        const redirectURL =
          row.original.status &&
            row.original.status.toLowerCase() === "not yet submitted"
            ? `order/${row.original.fileNumber}`
            : `ordersummary/${row.original.fileNumber}`;
        return (
          <div className="ml-3">
            <a href={redirectURL} className="fileNumber text-secondary-blue">
              {row.original.fileNumber}
            </a>
            {/* <br />
          <span className="internalReference">
            {row.original.internalReference}
          </span> */}
          </div>
        );
      },
    },
    {
      Header: t("fileorReferenceHeader"),
      accessor: "internalReference",
      width: 30,
      sortable: true,
    },
    ...(!userLogin?.isLawyer ? [{
      Header: t("LawyerNameHeader"),
      accessor: "lawyerName",
      width: 100,
      sortable: true

    }] : []),
    {
      Header: t("ClientNameHeader"),
      accessor: "clients",
      width: 140,
      expandLength: 16,
      expanded: false,
      Cell: ({ row }) => {
        //spread the props
        //const redirectURL = `process/${row.original.filenumberEncrypted}`;
        const clientsArray = row.original.clients.split(',');
        return (
          <div className="ml-3">
            {clientsArray.map((item) => {

              return (
                <div> {item}<br /></div>
              )
            })}

          </div>
        );
      },
    },
    {
      Header: t("PropertyAddressHeader"),
      accessor: "propertyAddress",
      width: 350,
      itemsToShow: 1,
      expandLength: 100,
      expanded: false,
      Cell: ({ row }) => {
        //spread the props
        //const redirectURL = `process/${row.original.filenumberEncrypted}`;
        const propArray = row.original.propertyAddress.split(';');
        return (
          <div className="ml-3">
            {propArray.map((item) => {

              return (
                <div> {item}<br /></div>
              )
            })}

          </div>
        );
      },
    },
    {
      Header: t("DealTypeHeader"),
      accessor: "dealType",
      width: 100,
      sortable: true,
    },
    {
      Header: t("ClosingDateHeader"),
      accessor: "closingDate",
      width: 100,
      expandLength: 16,
      sortable: true,
      expanded: false,
      Cell: ({ row }) => {
        //spread the props
        //const redirectURL = `process/${row.original.filenumberEncrypted}`;
        const dateArray = row.original.closingDate?.split(',');
        return (
          <div className="ml-3">
            {dateArray?.map((item) => {

              return (
                <div> {item}<br /></div>
              )
            })}

          </div>
        );
      },
    },
    {
      Header: "MissingInfo",
      accessor: "missingInfos",
      width: 0,
    },
    {
      Header: t("StatusHeader"),
      accessor: "status",
      width: 100,
      ToolTip: true,
      sortable: true,
      Cell: ({ row }) => {
        //spread the props
        const missinginfos = row.original.missingInfos?.split(',');

        return (
          <div className="ml-6">
            <div className="pendingStatus w-max ml-6">{getOrderStatusTipDetails(row.original.status, { t })}</div>
            <br />

            {PendingOrderProgressBarVisibleConstansts.includes(
              row.original.status
            ) && (
                <span className="progressbar">
                  <PendingOrderProgressBar
                    missinginfo={
                      missinginfos ? missinginfos : []
                    }
                    progressBarStatus={row.original.status}
                    fileID={row.original.fileNumber}
                  />
                </span>
              )}
          </div>
        );
      },
    },
  ];
};

export const formatRowData = (rawData, lang) => {
  return rawData?.map((info) => ({
    fileNumber: info.fileNumber,
    fileID: info.fileID,
    filenumberEncrypted: info.encryptedURL,
    lawyerName: info.lawyerName,
    internalReference: info.internalReference,
    propertyAddress: info.propertyAddress,
    status: info.status,
    clients: info.clients,
    closingDate:
      info.closingDate === null || info.closingDate === ""
        ? "-"
        : info.closingDate,
    province: info.province,
    dealType: info.co === "IDV" ? (lang == "en" ? "ID Verification" : "Vérification d'identité") : info.co === "Co" ? (lang == "en" ? "Commercial" : "Commercial") : (lang == "en" ? "Residential" : "Résidentiel"),
    icon: info.icon,
    missingInfos: info.missingInfos,
  }));
};

export const getData = async (pageNo = 1) => {
  const response = await fetch(
    `https://api.instantwebtools.net/v1/passenger?page=${pageNo}&size=15`
  );
};
